 
import React from "react";
import {
  ArrowUpRight,
  Car,
  RefreshCw,
  FileText,
  ShieldCheck,
} from "lucide-react";

import Immag from "./immaginefinale.jpg";

const servizi = [
  {
    titolo: "Consegui la tua patente",
    descrizione:
      "Teoria, esercitazioni e guida per arrivare pronto all'esame.",
    icona: Car,
    href: "#patenti",
    immagine: Immag,
    tag: ["AM", "A", "B", "C", "D", "E", "CAP", "CQC"],
  },
  {
    titolo: "Rinnovo patente",
    descrizione:
      "Rinnova la tua patente con una procedura semplice e assistenza durante ogni fase.",
    icona: RefreshCw,
    href: "#rinnovo",
    immagine: null,
  },
  {
    titolo: "Revisione",
    descrizione:
      "Ti aiutiamo a gestire la pratica di revisione della patente, con chiarezza e supporto.",
    icona: ShieldCheck,
    href: "#revisione",
    immagine: null,
  },
  {
    titolo: "Duplicato patente",
    descrizione:
      "Hai smarrito la patente o è danneggiata? Ti assistiamo nella richiesta del duplicato.",
    icona: FileText,
    href: "#duplicato",
    immagine: null,
  },
];

const Servizi = () => {
  return (
    <section
      id="servizi"
      className="relative overflow-hidden bg-[#FFF9EF] px-5 py-16 sm:px-8 sm:py-20 lg:px-12 lg:py-10"
    >
      {/* Decorazioni */}
      <div className="pointer-events-none absolute -right-32 top-20 h-80 w-80 rounded-full bg-[#FFC857]/20 blur-3xl" />

      <div className="pointer-events-none absolute -bottom-20 -left-32 h-80 w-80 rounded-full bg-[#123B6D]/5 blur-3xl" />

      <div className="relative mx-auto max-w-7xl">
        {/* Titolo */}
        <div className="mb-10 text-center sm:mb-14">
          <h2 className="text-4xl font-extrabold leading-tight tracking-tight text-[#123B6D] sm:text-5xl lg:text-6xl">
            Tutto quello che ti serve.
            <span className="mt-1 block text-[#D62828]">
              In un unico posto.
            </span>
          </h2>
        </div>

        {/* Griglia card */}
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:gap-8">
          {servizi.map((servizio) => {
            const Icona = servizio.icona;

            return (
              <a
                key={servizio.titolo}
                href={servizio.href}
                className="group flex min-h-[560px] flex-col overflow-hidden rounded-3xl border border-[#123B6D]/10 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl sm:min-h-[600px] lg:min-h-[620px]"
              >
                {/* METÀ SUPERIORE: IMMAGINE */}
                <div className="relative h-[280px] shrink-0 overflow-hidden bg-[#123B6D]/10 sm:h-[300px] lg:h-[310px]">
                  {servizio.immagine ? (
                    <img
                      src={servizio.immagine}
                      alt={servizio.titolo}
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  ) : (
                    <div className="flex h-full w-full items-center justify-center bg-gradient-to-br from-[#123B6D] to-[#1d568f]">
                      <Icona
                        size={88}
                        strokeWidth={1.3}
                        className="text-white/90 transition-transform duration-300 group-hover:scale-110"
                      />
                    </div>
                  )}

                  {/* Etichetta */}
                  <span className="absolute left-5 top-5 rounded-full bg-white px-4 py-2 text-xs font-extrabold uppercase tracking-wider text-[#123B6D] shadow-sm">
                    {servizio.titolo}
                  </span>
                </div>

                {/* SEPARATORE */}
                <div className="h-1 w-full bg-[#D62828] transition-all duration-300 group-hover:h-2" />

                {/* METÀ INFERIORE: TESTO */}
                <div className="flex flex-1 flex-col items-start p-6 sm:p-7 lg:p-8">
                  <h3 className="mb-3 text-2xl font-extrabold leading-tight text-[#123B6D] sm:text-3xl">
                    {servizio.titolo}
                  </h3>

                  <p className="text-base leading-relaxed text-slate-600">
                    {servizio.descrizione}
                  </p>

                  {servizio.tag && (
                    <div className="mt-5 flex flex-wrap gap-2">
                      {servizio.tag.map((tag) => (
                        <span
                          key={tag}
                          className="rounded-lg bg-[#FFF9EF] px-3 py-1.5 text-xs font-bold text-[#123B6D]"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  )}

                  <div className="mt-auto flex items-center gap-2 pt-6 text-sm font-bold text-[#D62828]">
                    Scopri il servizio
                    <ArrowUpRight
                      size={20}
                      className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
                    />
                  </div>
                </div>
              </a>
            );
          })}
        </div>

        {/* Contatti */}
        <div className="mt-12 text-center">
          <p className="mb-4 text-sm text-slate-600 sm:text-base">
            Hai bisogno di informazioni? Siamo qui per aiutarti.
          </p>

          <a
            href="#contatti"
            className="inline-flex items-center justify-center gap-2 rounded-xl bg-[#D62828] px-7 py-4 font-bold text-white shadow-md transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#b91f24] hover:shadow-lg"
          >
            Contattaci
            <ArrowUpRight size={20} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Servizi;
 